import { render, staticRenderFns } from "./baseInfoModules.vue?vue&type=template&id=e9295c98&scoped=true&"
import script from "./baseInfoModules.vue?vue&type=script&lang=js&"
export * from "./baseInfoModules.vue?vue&type=script&lang=js&"
import style0 from "./baseInfoModules.vue?vue&type=style&index=0&id=e9295c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9295c98",
  null
  
)

export default component.exports